/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2021 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/


 import React, { Component } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import { convertColumndef, convertRowData } from '../../common/tableConfig/gradeAnalyisConfig';
import tableStyle from '../../component/common/style/index.scss';
import style from '../../styles.module.scss';
import { EDWDropDown } from '../common/dropDown/DropDown';
import { ErrorMessage } from '../common/messaging/ErrorMessage';
import EDW_CONST from '../../common/constants'

export default class IsNoBlind extends React.Component {
    constructor(props) {
        super();
        this.state = {
            coloumnDef: [],
            rowData: [],
            icons: props.gradeConfig.icons,
            height: props.height,
            isColorblind: props.isColorblind,
            gradeConfig: props.gradeConfig,
            viewBy: props.viewBy,
            isDataExist: props.isDataExist,
            colorBlindview: props.colorBlindview,
            pinnedTopRow: props.pinnedTopRow,
            defaultColDef: props.defaultColDef
        };
    }
    componentDidMount() {

        this.generateGridConfig(this.state.gradeConfig, this.state.isColorblind, this.state.viewBy)
    }
    generateGridConfig(gradeConfig, isColorblind, viewBy) {

        let columndef = convertColumndef(false, viewBy, gradeConfig);
        let rowData = convertRowData(gradeConfig);
        let height = 150 + (parseInt(rowData.rowsArray.length) + parseInt(rowData.pinnedTopRow.length)) * 50;
        this.setState({ rowData: rowData.rowsArray, pinnedTopRow: rowData.pinnedTopRow, coloumnDef: columndef, isDataFetch: true, height:height });
        this.props.updateExportData({ type: "grade_widget_3", rowData: rowData, columnDefs: columndef });

    }
    sortByView = (value) => {
        if (value != this.state.viewBy) {
            this.setState({ viewBy: value });
            this.generateGridConfig(this.state.gradeConfig, this.state.isColorblind, value);
            this.gridApi.setColumnDefs(this.state.columndef);
        }

    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.refreshCells(params);
        this.gridApi.setColumnDefs(this.state.coloumnDef);
    };

    isKs4 = data => {
        return data && data.toLowerCase().indexOf('edexcel') > -1
    }
    sort_by_key = (array, key) => {
        return array.sort(function (a, b) {
            var x = a[key]; var y = b[key];
            return ((x < y) ? -1 : ((x > y) ? 1 : 0));
        });
    }
    onSortChanged = (params) => {
        let sortModel = params.api.getSortModel();
        let sortedRowData = this.sort_by_key(this.state.rowData, sortModel[0]["colId"]);
        this.setState({ rowData: sortedRowData });
    }
    componentDidUpdate(){
         this.props.updateExportData({ type: "grade_widget_3", rowData: { rowsArray: this.state.rowData, pinnedTopRow: this.state.pinnedTopRow }, columnDefs: this.state.coloumnDef });
    }

    render() {
        const isKs4 = this.isKs4(this.props.courseName || '');


        return (
            <div>

                <div className="col">
                    <div className="row contentFilter" style={{ alignItems: "flex-end" }}>
                        <div style={{ flex: 1, marginRight: !isKs4 || this.state.isDataExist ? 20 : undefined }}></div>
                        {this.state.isDataExist ? (
                            <div style={{ marginRight: !isKs4 ? 20 : undefined }} className={['checkboxCls', style.customCheckbox].join(" ")}>
                                <input type="checkbox" id="colorblind" className="checkbox" value={this.state.isColorblind} onChange={this.state.colorBlindview} checked={this.state.isColorblind} />
                                <label for="colorblind">Enable colourblind-friendly mode</label>
                            </div>
                        ) : (<div style={{ marginRight: !isKs4 ? 20 : undefined }} className="checkboxCls">

                        </div>)} 
                        {
                            !isKs4 && (
                                <div>
                                    <label className={style.lblColor}>View question data as</label>
                                    <EDWDropDown
                                        items={[{ label: 'Indicative grade', id: 'indicativeGrade' }, { label: 'Steps', id: 'steps' }]}
                                        onChange={this.sortByView}
                                        label="View question data as"
                                        value={this.state.viewBy}
                                    />
                                </div>
                            )
                        }
                    </div>
                    <div className="row ">
                        <div className="labelMarkleft checkboxCls" style={{ display: 'flex' }}>
                            <i className={[tableStyle.lowMarkcolor, 'iconAverage'].join(' ')} style={{ marginRight: 12 }}></i>
                            <p>Not on track</p>
                        </div>
                        <div className="col-md-4">
                        </div>
                        <div className="col-md-5"></div>
                    </div>
                    {
                        this.state.gradeConfig.duplicateYearError && (
                            <div className='row'>
                                <ErrorMessage message={EDW_CONST.DUPLICATE_YEAR_ERR_MSG} />
                            </div>
                        )
                    }
                </div>
                <div className="ag-theme-alpine" id="blind" style={{ height: '', width: 'auto' }}>
                    <AgGridReact tooltipShowDelay={0}
                        columnDefs={this.state.coloumnDef}
                        rowData={this.state.rowData}
                        icons={this.state.icons}
                        defaultColDef={this.state.defaultColDef}
                        onGridReady={this.onGridReady}
                        getRowHeight={this.props.getRowHeight}
                        pinnedTopRowData={this.state.pinnedTopRow}
                        domLayout="autoHeight"
                        onColumnResized={this.props.onColumnResized}
                        onSortChanged={this.onSortChanged.bind(this)}
                    // pagination={true}
                    // paginationPageSize={12}
                    // icons={this.state.icons}
                    // onCellClicked={this.onCellClicked}

                    >
                    </AgGridReact>
                </div>
            </div>
        )
    }
}